<!--
    描述：企业管理
    时间：2020-09-24
    Created by ws
-->
<template>
    <div class="">

    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped lang="less">
</style>
